<template>
  <el-container>
    <el-header>
      <head_page :head_page_type=false ref="head_page"></head_page>
    </el-header>

    <el-main style="margin-top: 15px;">
      <head_menu :has-back=true @go-back-click="goBack">
        <template #title>
          <div style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:5px;font-size: 20px;">
            {{chosen_city}}
          </div>
        </template>
        <template #button-group-right>
          <el-button @click="goInventoryHistory">{{ $t('message.Upload_History') }}
          </el-button>
        </template>
      </head_menu>
      <div>
        <el-row style="margin-top:20px; padding: 5px 0; background-color: rgb(240, 240, 238);">
          <el-col :span="12" style="text-align: left">
            <el-button type="success" icon="el-icon-plus" @click="addDialogFormVisible=true" >{{$t('message.Create')}}</el-button>
            <!--<el-button type="danger" icon="el-icon-close" >{{$t('message.Delete')}}</el-button>-->
            <el-popover placement="right-start" trigger="click" transition="fade-in-linear" visible-arrow=false
              style="padding: 0;" v-model="filterFormVisible">
              <el-form ref="filterForm" size="small" :inline=true label-position="right"  style="width: 300px; margin:10px auto">
                <el-row>
                  <el-col :span="5" :offset="1">
                    <div class="filer-form-label">
                      {{$t('message.Bus_line')}}
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <el-form-item>
                      <el-input :placeholder="$t('message.Bus_line')" v-model="busLineKeyword" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5" :offset="1">
                    <div class="filer-form-label">
                      {{$t('message.Plate')}}
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <el-form-item>
                      <el-input :placeholder="$t('message.Plate')" v-model="plateKeyword" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="5" :offset="1">
                    <div class="filer-form-label">
                      {{$t('message.Bus_id')}}
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <el-form-item>
                      <el-input :placeholder="$t('message.Bus_id')" v-model="busIdKeyword" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row style="margin: auto">
                  <el-button @click="filterHandler" 
                    :class="{ 'is-disabled': busLineKeyword.length === 0 && plateKeyword.length === 0 && busIdKeyword.length === 0}"
                    :disabled="busLineKeyword.length === 0 && plateKeyword.length === 0 && busIdKeyword.length === 0" >
                    {{$t('message.Filter_Confirm')}}
                  </el-button>
                  <el-button @click="filterResetHandler">{{$t('message.Reset')}}</el-button>
                </el-row>
              </el-form>
              <el-button style="margin-left: 10px" slot="reference" icon="el-icon-s-operation">{{$t('message.Filter')}}</el-button>
            </el-popover>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <el-button type="primary" icon="el-icon-upload2" @click="exportExcel" >{{$t('message.Export')}}</el-button>
          </el-col>
        </el-row>
        <el-table :data="inventory_list" style="width: 100%"
          :header-cell-style="rowClass"
          @sort-change="handleAuditSortChange"
          tooltip-effect="light"
          >
          <el-table-column min-width="80" width="80">
            <template slot-scope="scope">
              <div>
                <!--<input style="font-size: 18px; padding: 0 5px;" type="checkbox" @click="checkBusBody($event, scope.row)"/>-->
                <i style="font-size: 20px; padding: 0 5px; cursor: pointer; color: darkblue;" class="el-icon-edit-outline" @click="showEditDialogFrom(scope.row)"></i>
                <i style="font-size: 20px; padding: 0 5px; cursor: pointer; color: red;" class="el-icon-close" @click="openDeleteMessageBox(scope.row)"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.Bus_line')" prop="line" min-width="60" width="80">
            <template slot-scope="scope" slot="header">
              <span :class="{ 'highlight': busLineKeywordHighlight }">{{$t('message.Bus_line')}}</span>
              <span class="el-table__column-filter-trigger"></span>
              <el-popover placement="bottom" trigger="click" transition="el-zoom-in-top" visible-arrow=false
                style="padding: 0;" v-model="busLineKeywordVisible">
                <div class="inventory-list-table-filter">
                  <div class="inventory-list-table-filter__content">
                    <div class="sub-title">{{$t('message.Search_bus_line')}}</div>
                    <input class="search-input" type="text" :placeholder="$t('message.Please_enter_keyword')" v-model="busLineKeyword" />
                  </div>
                  <div class="inventory-list-table-filter__bottom">
                    <button @click="busLineFilterHandler" 
                      :class="{ 'is-disabled': busLineKeyword.length === 0 }"
                      :disabled="busLineKeyword.length === 0" >{{$t('message.Filter_Confirm')}}</button>
                    <button @click="busLineResetHandler">{{$t('message.Reset')}}</button>
                  </div>
                </div>
                <span  :class="{ 'highlight': true }" style="cursor: pointer; margin-left: 5px; margin-top: -15px;" slot="reference"><i class="el-icon-search"></i></span>
              </el-popover>
            </template>
            <template slot-scope="scope">
              <div>{{ scope.row.line.replace("line_", "") }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.Ranking')" prop="ranking" min-width="60" width="80">
          </el-table-column>
          <el-table-column :label="$t('message.Plate')" prop="plate" min-width="100" width="120">
            <template slot-scope="scope" slot="header">
              <span :class="{ 'highlight': plateKeywordHighlight }">{{$t('message.Plate')}}</span>
              <span class="el-table__column-filter-trigger"></span>
              <el-popover placement="bottom" trigger="click" transition="el-zoom-in-top" visible-arrow=false
                style="padding: 0;" v-model="plateKeywordVisible">
                <div class="inventory-list-table-filter">
                  <div class="inventory-list-table-filter__content">
                    <div class="sub-title">{{$t('message.Search_plate')}}</div>
                    <input class="search-input" type="text" :placeholder="$t('message.Please_enter_keyword')" v-model="plateKeyword" />
                  </div>
                  <div class="inventory-list-table-filter__bottom">
                    <button @click="plateFilterHandler" 
                      :class="{ 'is-disabled': plateKeyword.length === 0 }"
                      :disabled="plateKeyword.length === 0" >{{$t('message.Filter_Confirm')}}</button>
                    <button @click="plateResetHandler">{{$t('message.Reset')}}</button>
                  </div>
                </div>
                <span  :class="{ 'highlight': true }" style="cursor: pointer; margin-left: 5px; margin-top: -15px;" slot="reference"><i class="el-icon-search"></i></span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.Bus_id')" prop="bus_id" min-width="80" width="100">
            <template slot-scope="scope" slot="header">
              <span :class="{ 'highlight': busIdKeywordHighlight }">{{$t('message.Bus_id')}}</span>
              <span class="el-table__column-filter-trigger"></span>
              <el-popover placement="bottom" trigger="click" transition="el-zoom-in-top" visible-arrow=false
                style="padding: 0;" v-model="busIdKeywordVisible">
                <div class="inventory-list-table-filter">
                  <div class="inventory-list-table-filter__content">
                    <div class="sub-title">{{$t('message.Search_bus_id')}}</div>
                    <input class="search-input" type="text" :placeholder="$t('message.Please_enter_keyword')" v-model="busIdKeyword" />
                  </div>
                  <div class="inventory-list-table-filter__bottom">
                    <button @click="busIdFilterHandler" 
                      :class="{ 'is-disabled': busIdKeyword.length === 0 }"
                      :disabled="busIdKeyword.length === 0" >{{$t('message.Filter_Confirm')}}</button>
                    <button @click="busIdResetHandler">{{$t('message.Reset')}}</button>
                  </div>
                </div>
                <span  :class="{ 'highlight': true }" style="cursor: pointer; margin-left: 5px; margin-top: -15px;" slot="reference"><i class="el-icon-search"></i></span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.Bus_model')" prop="bus_model" min-width="80" width="140">
          </el-table-column>
          <el-table-column :label="$t('message.Media_Format')" min-width="140" width="160">
            <template slot-scope="scope">
              <div v-if="scope.row.single_deck_2_panels == 1">{{$t('message.single_deck_2_panels')}}</div>
              <div v-if="scope.row.single_deck_3_panels == 1">{{$t('message.single_deck_3_panels')}}</div>
              <div v-if="scope.row.single_deck_half_bus_wrap == 1">{{$t('message.single_deck_half_bus_wrap')}}</div>
              <div v-if="scope.row.single_deck_full_bus_wrap == 1">{{$t('message.single_deck_full_bus_wrap')}}</div>
              <div v-if="scope.row.single_deck_full_bus_wrap_plus == 1">{{$t('message.single_deck_full_bus_wrap_plus')}}</div>
              <div v-if="scope.row.double_deck_full_bus_wrap == 1">{{$t('message.double_deck_full_bus_wrap')}}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.Status')" prop="vehicle_status" min-width="80" width="120">
            <template slot-scope="scope">
              <div >{{$t('message.vehicle_status_'+scope.row.vehicle_status)}}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.Status_start')" prop="status_start" min-width="80" width="120">
          </el-table-column>
          <el-table-column :label="$t('message.Status_end')" prop="status_end" min-width="80" width="120">
          </el-table-column>
          <el-table-column :label="$t('message.Reservation_start')" prop="reservation_start" min-width="80" width="120">
          </el-table-column>
          <el-table-column :label="$t('message.Reservation_end')" prop="reservation_end" min-width="80" width="120">
          </el-table-column>
          <el-table-column :label="$t('message.Contract_start')" prop="contract_start" min-width="80" width="120">
          </el-table-column>
          <el-table-column :label="$t('message.Contract_end')" prop="contract_end" min-width="80" width="120">
          </el-table-column>
          <el-table-column :label="$t('message.Production_start')" prop="production_start" min-width="80" width="120">
          </el-table-column>
          <el-table-column :label="$t('message.Production_end')" prop="production_end" min-width="80" width="120">
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize">
        </el-pagination>
      </div>
      <div class="card" style="margin-top: 20px">
      </div>
    </el-main>
    <el-dialog
        :title="$t('message.add_bus_body')"
        :visible.sync="addDialogFormVisible"
        :close-on-click-modal="false"
        :show-close="false"
        width=70%
      >
      <el-form :model="form_add" :rules="rules_add" ref="addForm" size="small" :inline=true label-position="right"  style="width: 600px; margin:auto">
        <el-row>
          <el-col :span="3">
            <div class="inv-form-label">
              {{$t('message.Bus_line')}}
            </div>
          </el-col>
          <el-col :span="9">
            <el-form-item>
              <el-input v-model="form_add.line"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <div class="inv-form-label">
              {{$t('message.Ranking')}}
            </div>
          </el-col>
          <el-col :span="9">
            <el-form-item>
              <el-select size="small" v-model="form_add.ranking" :placeholder="$t('message.Please_select_rank')">
                <el-option label="S" value="S"></el-option>
                <el-option label="A++" value="A++"></el-option>
                <el-option label="A+" value="A+"></el-option>
                <el-option label="A" value="A"></el-option>
                <el-option v-if="$route.chosen == 'Chongqing'" label="B" value="B"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="inv-form-label">
              {{$t('message.Plate')}}
            </div>
          </el-col>
          <el-col :span="9">
            <el-form-item prop="plate">
              <el-input v-model="form_add.plate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <div class="inv-form-label">
              {{$t('message.Bus_id')}}
            </div>
          </el-col>
          <el-col :span="9">
            <el-form-item>
              <el-input v-model="form_add.bus_id"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="inv-form-label">
              {{$t('message.Bus_model')}}
            </div>
          </el-col>
          <el-col :span="9">
            <el-form-item>
              <el-input v-model="form_add.bus_model"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="inv-form-label">
              {{$t('message.Media_Format')}}
            </div>
          </el-col>
          <el-col :span="20" :offset="0" style="text-align: left;">
            <el-form-item>
              <el-checkbox v-model="form_add.single_deck_2_panels" true-label="1" false-label="">{{$t('message.single_deck_2_panels')}}</el-checkbox>
              <el-checkbox v-model="form_add.single_deck_3_panels" true-label="1" false-label="">{{$t('message.single_deck_3_panels')}}</el-checkbox>
              <el-checkbox v-model="form_add.single_deck_half_bus_wrap" true-label="1" false-label="">{{$t('message.single_deck_half_bus_wrap')}}</el-checkbox>
              <el-checkbox v-model="form_add.single_deck_full_bus_wrap" true-label="1" false-label="">{{$t('message.single_deck_full_bus_wrap')}}</el-checkbox>
              <el-checkbox v-model="form_add.single_deck_full_bus_wrap_plus" true-label="1" false-label="">{{$t('message.single_deck_full_bus_wrap_plus')}}</el-checkbox>
              <el-checkbox v-model="form_add.double_deck_full_bus_wrap" true-label="1" false-label="">{{$t('message.double_deck_full_bus_wrap')}}</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="inv-form-label">
              {{$t('message.Status')}}
            </div>
          </el-col>
          <el-col :span="9" :offset="1">
            <el-form-item>
              <el-select size="small" v-model="form_add.vehicle_status" :placeholder="$t('message.Please_select_status')">
                <el-option :label="$t('message.vehicle_status_0')" :value=0></el-option>
                <el-option :label="$t('message.vehicle_status_1')" :value=1></el-option>
                <el-option :label="$t('message.vehicle_status_2')" :value=2></el-option>
                <el-option :label="$t('message.vehicle_status_3')" :value=3></el-option>
                <el-option :label="$t('message.vehicle_status_4')" :value=4></el-option>
                <el-option :label="$t('message.vehicle_status_5')" :value=5></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="inv-form-label">
              {{$t('message.Status_date_range')}}
            </div>
          </el-col>
          <el-col :span="9" :offset="1">
            <el-form-item>
              <el-date-picker
                unlink-panels
                v-model="form_add.status_range"
                type="daterange"
                :range-separator="$t('message.to')"
                :start-placeholder="$t('message.Start_date')"
                :end-placeholder="$t('message.End_date')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="inv-form-label">
              {{$t('message.Reservation_date_range')}}
            </div>
          </el-col>
          <el-col :span="9" :offset="1">
            <el-form-item>
              <el-date-picker
                unlink-panels
                v-model="form_add.reservation_range"
                type="daterange"
                :range-separator="$t('message.to')"
                :start-placeholder="$t('message.Start_date')"
                :end-placeholder="$t('message.End_date')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="inv-form-label">
              {{$t('message.Contract_date_range')}}
            </div>
          </el-col>
          <el-col :span="9" :offset="1">
            <el-form-item>
              <el-date-picker
                unlink-panels
                v-model="form_add.contract_range"
                type="daterange"
                :range-separator="$t('message.to')"
                :start-placeholder="$t('message.Start_date')"
                :end-placeholder="$t('message.End_date')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="inv-form-label">
              {{$t('message.Production_date_range')}}
            </div>
          </el-col>
          <el-col :span="9" :offset="1">
            <el-form-item>
              <el-date-picker
                unlink-panels
                v-model="form_add.production_range"
                type="daterange"
                :range-separator="$t('message.to')"
                :start-placeholder="$t('message.Start_date')"
                :end-placeholder="$t('message.End_date')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-form-item>
            <el-button type="primary" @click="validateAddForm('addForm')">{{$t('message.Create')}}</el-button>
            <el-button @click="closeFormAdd()">{{$t('message.Cancel')}}</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog
        :title="$t('message.edit_bus_body')"
        :visible.sync="editDialogFormVisible"
        :close-on-click-modal="false"
        :show-close="false"
        width=70%
      >
      <el-form :model="form_edit" ref="editForm" size="small" :inline=true label-position="right"  style="width: 600px; margin:auto">
        <el-row>
          <el-col :span="3">
            <div class="inv-form-label">
              {{$t('message.Bus_line')}}
            </div>
          </el-col>
          <el-col :span="9">
            <el-form-item>
              <el-input v-model="form_edit.line"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <div class="inv-form-label">
              {{$t('message.Ranking')}}
            </div>
          </el-col>
          <el-col :span="9">
            <el-form-item>
              <el-select size="small" v-model="form_edit.ranking" :placeholder="$t('message.Please_select_rank')">
                <el-option label="S" value="S"></el-option>
                <el-option label="A++" value="A++"></el-option>
                <el-option label="A+" value="A+"></el-option>
                <el-option label="A" value="A"></el-option>
                <el-option v-if="$route.chosen == 'Chongqing'" label="B" value="B"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="inv-form-label">
              {{$t('message.Plate')}}
            </div>
          </el-col>
          <el-col :span="9">
            <el-form-item prop="plate">
              <el-input v-model="form_edit.plate" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <div class="inv-form-label">
              {{$t('message.Bus_id')}}
            </div>
          </el-col>
          <el-col :span="9">
            <el-form-item>
              <el-input v-model="form_edit.bus_id"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="inv-form-label">
              {{$t('message.Bus_model')}}
            </div>
          </el-col>
          <el-col :span="9">
            <el-form-item>
              <el-input v-model="form_edit.bus_model"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="inv-form-label">
              {{$t('message.Media_Format')}}
            </div>
          </el-col>
          <el-col :span="20" :offset="0" style="text-align: left;">
            <el-form-item>
              <el-checkbox v-model="form_edit.single_deck_2_panels" :true-label="1" false-label="">{{$t('message.single_deck_2_panels')}}</el-checkbox>
              <el-checkbox v-model="form_edit.single_deck_3_panels" :true-label="1" false-label="">{{$t('message.single_deck_3_panels')}}</el-checkbox>
              <el-checkbox v-model="form_edit.single_deck_half_bus_wrap" :true-label="1" false-label="">{{$t('message.single_deck_half_bus_wrap')}}</el-checkbox>
              <el-checkbox v-model="form_edit.single_deck_full_bus_wrap" :true-label="1" false-label="">{{$t('message.single_deck_full_bus_wrap')}}</el-checkbox>
              <el-checkbox v-model="form_edit.single_deck_full_bus_wrap_plus" :true-label="1" false-label="">{{$t('message.single_deck_full_bus_wrap_plus')}}</el-checkbox>
              <el-checkbox v-model="form_edit.double_deck_full_bus_wrap" :true-label="1" false-label="">{{$t('message.double_deck_full_bus_wrap')}}</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="inv-form-label">
              {{$t('message.Status')}}
            </div>
          </el-col>
          <el-col :span="9" :offset="1">
            <el-form-item>
              <el-select size="small" v-model="form_edit.vehicle_status" :placeholder="$t('message.Please_select_status')">
                <el-option :label="$t('message.vehicle_status_0')" :value=0></el-option>
                <el-option :label="$t('message.vehicle_status_1')" :value=1></el-option>
                <el-option :label="$t('message.vehicle_status_2')" :value=2></el-option>
                <el-option :label="$t('message.vehicle_status_3')" :value=3></el-option>
                <el-option :label="$t('message.vehicle_status_4')" :value=4></el-option>
                <el-option :label="$t('message.vehicle_status_5')" :value=5></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="inv-form-label">
              {{$t('message.Status_date_range')}}
            </div>
          </el-col>
          <el-col :span="9" :offset="1">
            <el-form-item>
              <el-date-picker
                unlink-panels
                v-model="form_edit.status_range"
                type="daterange"
                :range-separator="$t('message.to')"
                :start-placeholder="$t('message.Start_date')"
                :end-placeholder="$t('message.End_date')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="inv-form-label">
              {{$t('message.Reservation_date_range')}}
            </div>
          </el-col>
          <el-col :span="9" :offset="1">
            <el-form-item>
              <el-date-picker
                unlink-panels
                v-model="form_edit.reservation_range"
                type="daterange"
                :range-separator="$t('message.to')"
                :start-placeholder="$t('message.Start_date')"
                :end-placeholder="$t('message.End_date')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="inv-form-label">
              {{$t('message.Contract_date_range')}}
            </div>
          </el-col>
          <el-col :span="9" :offset="1">
            <el-form-item>
              <el-date-picker
                unlink-panels
                v-model="form_edit.contract_range"
                type="daterange"
                :range-separator="$t('message.to')"
                :start-placeholder="$t('message.Start_date')"
                :end-placeholder="$t('message.End_date')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="inv-form-label">
              {{$t('message.Production_date_range')}}
            </div>
          </el-col>
          <el-col :span="9" :offset="1">
            <el-form-item>
              <el-date-picker
                unlink-panels
                v-model="form_edit.production_range"
                type="daterange"
                :range-separator="$t('message.to')"
                :start-placeholder="$t('message.Start_date')"
                :end-placeholder="$t('message.End_date')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-form-item>
            <el-button type="primary" @click="editBusBody">{{$t('message.Edit')}}</el-button>
            <el-button @click="closeFormEdit()">{{$t('message.Cancel')}}</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
  import head_page from './components/head_page.vue';
  import head_menu from './components/head_menu.vue';
  import axios from 'axios';
  import _global from './components/global.vue';
  export default {
    name: 'inventory_list',
    data() {
      return {
        timeOffset: (new Date()).getTimezoneOffset() * 60000,
        loading: true,
        chosen_city: this.$route.query.chosen_city,
        inventory_list: [],
        currentPage: 1,
        pageSize: 10,
        totalSize: 0,
        sortProps: {
          column: {},
          order: null,
          prop: "",
        },
        addDialogFormVisible: false,
        form_add: {
          city : this.$route.query.chosen_city,
          line : "",
          ranking : "",
          plate : "",
          bus_id : "",
          bus_model : "",
          single_deck_2_panels : "",
          single_deck_3_panels : "",
          single_deck_half_bus_wrap : "",
          single_deck_full_bus_wrap : "",
          single_deck_full_bus_wrap_plus : "",
          double_deck_full_bus_wrap : "",
          vehicle_status : 0,
          status_start : "",
          status_end : "",
          status_range: [],
          reservation_start : "",
          reservation_end : "",
          reservation_range: [],
          contract_start : "",
          contract_end : "",
          contract_range: [],
          production_start : "",
          production_end : "",
          production_range: [],
        },
        rules_add: {
          plate: [
            { required: true, message: this.$t('message.Required_field'), trigger: 'blur' },
          ]
        },
        editDialogFormVisible: false,
        form_edit: {
          city : this.$route.query.chosen_city,
          line : "",
          ranking : "",
          plate : "",
          bus_id : "",
          bus_model : "",
          single_deck_2_panels : 0,
          single_deck_3_panels : 0,
          single_deck_half_bus_wrap : 0,
          single_deck_full_bus_wrap : 0,
          single_deck_full_bus_wrap_plus : 0,
          double_deck_full_bus_wrap : 0,
          vehicle_status : 0,
          status_start : "",
          status_end : "",
          status_range: [],
          reservation_start : "",
          reservation_end : "",
          reservation_range: [],
          contract_start : "",
          contract_end : "",
          contract_range: [],
          production_start : "",
          production_end : "",
          production_range: [],
        },
        busLineKeyword: "",
        busLineKeywordVisible: false,
        busLineKeywordHighlight: false,
        plateKeyword: "",
        plateKeywordVisible: false,
        plateKeywordHighlight: false,
        busIdKeyword: "",
        busIdKeywordVisible: false,
        busIdKeywordHighlight: false,
        filterFormVisible: false,
      }
    },
    computed: {
    },
    components: {
      head_page,
      head_menu
    },
    created() {
      
    },
    mounted() {
      this.$refs.head_page.update_user_name();
      this.getInventoryList();
    },
    methods: {
      goBack(){
        this.$router.back()
      },
      goInventoryHistory() {
        this.$router.push({
          path: '/inventory_history',
          query: {
            chosen_city: this.chosen_city
          }
        });
      },
      getInventoryList() {
        this.loading = true
        let payload = {
          "email": JSON.parse(sessionStorage.getItem('User')),
          "chosen_city": this.$route.query.chosen_city,
          "currentPage": this.currentPage,
          "pageSize": this.pageSize,
          "busLineKeyword": this.busLineKeyword,
          "plateKeyword": this.plateKeyword,
          "busIdKeyword": this.busIdKeyword,
        }
        let api_url = _global.serverSrc + '/get_inventory_list_by_city/';
        this.$axios.post(api_url, payload).then(response => {
          if (response.data) {
            this.inventory_list = []
            this.loading = false
            this.inventory_list = response.data.inventory_list
            this.totalSize = response.data.total_number
          }
        })
        .catch(error=> {
          console.log(error)
        });
      },
      exportExcel() {
        let payload = {
          "email": JSON.parse(sessionStorage.getItem('User')),
          "chosen_city": this.$route.query.chosen_city,
        }
        let api_url = _global.serverSrc + '/export_inventory_as_excel/';
        this.$axios.post(api_url, payload, {responseType: 'blob'}).then(response => {
          let blob = new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          })
          // 切割出文件名
          let fileName = response.headers['content-disposition'].split("filename=")[1];
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, fileName)
          } else {
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = fileName
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
        })
      },
      handleAuditSortChange(sortProps) {
        this.sortProps = sortProps
        this.getInventoryList()
      },
      handleSizeChange(val) {
        this.currentPage = this.currentPage*this.pageSize/val + this.currentPage*this.pageSize%val==0 ? 0:1
        this.pageSize = val;
        this.getInventoryList()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getInventoryList()
      },
      rowClass({ rowIndex, columnIndex }) {
        if (rowIndex === 0) {       
            return {background:'#254A6E',color:'white'}
        }
      },
      validateAddForm() {
        this.$refs['addForm'].validate((valid) => {
          console.log(valid)
          if (valid) {
            this.createBusBody()
          } else {
            return false;
          }
        });

      },
      createBusBody() {
        let bus_body = this.form_add
        bus_body.status_start = bus_body.status_range.length > 0 ? new Date(new Date(bus_body.status_range[0]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.status_end = bus_body.status_range.length > 0 ? new Date(new Date(bus_body.status_range[1]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.reservation_start = bus_body.reservation_range.length > 0 ? new Date(new Date(bus_body.reservation_range[0]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.reservation_end = bus_body.reservation_range.length > 0 ? new Date(new Date(bus_body.reservation_range[1]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.contract_start = bus_body.contract_range.length > 0 ? new Date(new Date(bus_body.contract_range[0]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.contract_end = bus_body.contract_range.length > 0 ? new Date(new Date(bus_body.contract_range[1]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.production_start = bus_body.production_range.length > 0 ? new Date(new Date(bus_body.production_range[0]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.production_end = bus_body.production_range.length > 0 ? new Date(new Date(bus_body.production_range[1]) - this.timeOffset).toISOString().split('T')[0] : ""
        delete bus_body.status_range
        delete bus_body.reservation_range
        delete bus_body.contract_range
        delete bus_body.production_range
        let payload = {
          "email": JSON.parse(sessionStorage.getItem('User')),
          "chosen_city": this.$route.query.chosen_city,
          "bus_body": bus_body
        }
        let api_url = _global.serverSrc + '/add_bus_body/';
        this.$axios.post(api_url, payload).then(response => {
          if (response.data) {
            const message = response.data.message
            this.$message({
              message: this.$t('message.'+message[1]),
              type: message[0]
            });
            this.getInventoryList()
          }
          this.closeFormAdd()
        })
        .catch(error=> {
          console.log(error)
          this.closeFormAdd()
        });
      },
      closeFormAdd() {
        this.addDialogFormVisible = false;
        this.$refs['addForm'].resetFields();
        this.form_add = {
          city : this.$route.query.chosen_city,
          line : "",
          ranking : "",
          plate : "",
          bus_id : "",
          bus_model : "",
          single_deck_2_panels : "",
          single_deck_3_panels : "",
          single_deck_half_bus_wrap : "",
          single_deck_full_bus_wrap : "",
          single_deck_full_bus_wrap_plus : "",
          double_deck_full_bus_wrap : "",
          vehicle_status : 0,
          status_start : "",
          status_end : "",
          status_range: [],
          reservation_start : "",
          reservation_end : "",
          reservation_range: [],
          contract_start : "",
          contract_end : "",
          contract_range: [],
          production_start : "",
          production_end : "",
          production_range: [],
        }
      },
      showEditDialogFrom(row) {
        this.form_edit = {}
        row.status_range = row.status_start ? [row.status_start, row.status_end] : []
        row.reservation_range = row.reservation_start ? [row.reservation_start, row.reservation_end] : []
        row.contract_range = row.contract_start ? [row.contract_start, row.contract_end] : []
        row.production_range = row.production_start ? [row.production_start, row.production_end] : []
        this.form_edit = {...row}
        this.editDialogFormVisible = true
      },
      editBusBody() {
        let bus_body = this.form_edit
        bus_body.status_start = bus_body.status_range.length > 0 ? new Date(new Date(bus_body.status_range[0]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.status_end = bus_body.status_range.length > 0 ? new Date(new Date(bus_body.status_range[1]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.reservation_start = bus_body.reservation_range.length > 0 ? new Date(new Date(bus_body.reservation_range[0]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.reservation_end = bus_body.reservation_range.length > 0 ? new Date(new Date(bus_body.reservation_range[1]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.contract_start = bus_body.contract_range.length > 0 ? new Date(new Date(bus_body.contract_range[0]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.contract_end = bus_body.contract_range.length > 0 ? new Date(new Date(bus_body.contract_range[1]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.production_start = bus_body.production_range.length > 0 ? new Date(new Date(bus_body.production_range[0]) - this.timeOffset).toISOString().split('T')[0] : ""
        bus_body.production_end = bus_body.production_range.length > 0 ? new Date(new Date(bus_body.production_range[1]) - this.timeOffset).toISOString().split('T')[0] : ""
        delete bus_body.status_range
        delete bus_body.reservation_range
        delete bus_body.contract_range
        delete bus_body.production_range
        let payload = {
          "email": JSON.parse(sessionStorage.getItem('User')),
          "chosen_city": this.$route.query.chosen_city,
          "bus_body": bus_body
        }
        let api_url = _global.serverSrc + '/edit_bus_body/';
        this.$axios.post(api_url, payload).then(response => {
          if (response.data) {
            const message = response.data.message
            this.$message({
              message: this.$t('message.'+message[1]),
              type: message[0]
            });
            this.getInventoryList()
          }
          this.closeFormEdit()
        })
        .catch(error=> {
          console.log(error)
          this.closeFormEdit()
        });
      },
      closeFormEdit() {
        this.editDialogFormVisible = false;
      },
      openDeleteMessageBox(row) {
        this.$confirm(this.$t('message.Bus_body_delete_notice').replace("plate", row.plate), this.$t('message.Notice'), {
          confirmButtonText: this.$t('message.Notice_Yes'),
          cancelButtonText: this.$t('message.Notice_Cancel'),
          type: 'warning'
        }).then(() => {
          this.deleteBusBody(row.plate)
        }).catch(() => {
        });
      },
      deleteBusBody(plate) {
        let payload = {
          "email": JSON.parse(sessionStorage.getItem('User')),
          "chosen_city": this.$route.query.chosen_city,
          "plate": plate
        }
        let api_url = _global.serverSrc + '/delete_bus_body/';
        this.$axios.post(api_url, payload).then(response => {
          if (response.data) {
            const message = response.data.message
            this.$message({
              message: this.$t('message.'+message[1]),
              type: message[0]
            });
            this.getInventoryList()
          }
        })
        .catch(error=> {
          console.log(error)
        });
      },
      busLineFilterHandler() {
        if (this.busLineKeyword == "")
          return this.busLineResetHandler()
        this.busLineKeywordVisible = false;
        this.currentPage = 1
        this.busLineKeywordHighlight = true;
        this.getInventoryList()
      },
      busLineResetHandler() {
        this.busLineKeywordVisible = false;
        this.busLineKeyword = ""
        this.currentPage = 1
        this.busLineKeywordHighlight = false;
        this.getInventoryList()
      },
      plateFilterHandler() {
        if (this.plateKeyword == "")
          return this.plateResetHandler()
        this.plateKeywordVisible = false;
        this.currentPage = 1
        this.plateKeywordHighlight = true;
        this.getInventoryList()
      },
      plateResetHandler() {
        this.plateKeywordVisible = false;
        this.plateKeyword = ""
        this.currentPage = 1
        this.plateKeywordHighlight = false;
        this.getInventoryList()
      },
      busIdFilterHandler() {
        if (this.busIdKeyword == "")
          return this.busIdResetHandler()
        this.busIdKeywordVisible = false;
        this.currentPage = 1
        this.busIdKeywordHighlight = true;
        this.getInventoryList()
      },
      busIdResetHandler() {
        this.busIdKeywordVisible = false;
        this.busIdKeyword = ""
        this.currentPage = 1
        this.busIdKeywordHighlight = false;
        this.getInventoryList()
      },
      filterHandler() {
        if (this.busLineKeyword == "" && this.plateKeyword == "" && this.busIdKeyword == "")
          return this.filterResetHandler()
        this.filterFormVisible = false;
        this.currentPage = 1
        this.busLineKeywordHighlight = !(this.busLineKeyword == "");
        this.plateKeywordHighlight = !(this.plateKeyword == "");
        this.busIdKeywordHighlight = !(this.busIdKeyword == "");
        this.getInventoryList()
      },
      filterResetHandler() {
        this.filterFormVisible = false;
        this.busLineKeyword = ""
        this.plateKeyword = ""
        this.busIdKeyword = ""
        this.currentPage = 1
        this.busLineKeywordHighlight = false;
        this.plateKeywordHighlight = false;
        this.busIdKeywordHighlight = false;
        this.getInventoryList()
      },
    },
  }
</script>

<style lang="scss">
  .el-popover {
    min-width: 80px;
  }

  .inventory-list-table-filter {
    margin: -12px;

    .inventory-list-table-filter__content{
      padding: 10px 10px 0 10px;

      .sub-title {
        margin: 5px;
        line-height: 19px;
        font-size: 14px;
      }
      
      .search-input {
        margin: 5px;
        -webkit-appearance: none;
        background-color: #FFFFFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: none;
        padding: 0 15px;
        -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 200px;
      }

      input::-webkit-input-placeholder {
        color: #DCDFE6;
      }

      .el-checkbox {
        display: block;
        margin: 0 0 10px 10px;

        .el-checkbox__label {
          margin: 0 5px;
        }
      }
    }

    .inventory-list-table-filter__bottom {
      border-top: 1px solid #EBEEF5;
      padding: 13px;

      button {
        background: transparent;
        border: none;
        color: #606266;
        cursor: pointer;
        font-size: 13px;
        padding: 0 3px;

        
      }

      button.is-disabled {
        color: #C0C4CC;
        cursor: not-allowed;
      }
    }    
  }
</style>

<style lang="scss" scoped>
  /deep/ .p-datatable .p-datatable-tbody > tr > td {
    //word-break: break-all;
    font-size: 13px;
  }

  /deep/ .p-datatable .p-datatable-thead > tr > th {
    font-size: 14px;
  }

  /deep/ .p-component {
    font-size: 13px;
  }

  /deep/ .p-filter-column {
    padding: 0.5rem 0.5rem !important;
  }

  /deep/ .p-inputtext {
    font-size: 12px;
    padding: 0.5rem 0.2rem;
    text-align: left;
  }

  /deep/ .pi {
    font-size: 12px;
  }

  /deep/ .p-dropdown-trigger {
    width: 20px;
  }

  .card {
    background: var(--surface-e);
    padding: 2rem;
    -webkit-box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    margin-bottom: 2rem;
  }

  span.highlight{
    color: #409EFF;
  }

  /deep/.el-table__column-filter-trigger i {
    font-weight: bold;
    font-size: 18px;
    color: BLUE;
  }
  
  .audit-table-filter {
    margin: -12px;

    .audit-table-filter__content{
      padding: 10px 10px 0 10px;

      .sub-title {
        margin: 5px;
        line-height: 19px;
        font-size: 14px;
      }
      
      .search-input {
        margin: 5px;
        -webkit-appearance: none;
        background-color: #FFFFFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: none;
        padding: 0 15px;
        -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 200px;
      }

      input::-webkit-input-placeholder {
        color: #DCDFE6;
      }

      .el-checkbox {
        display: block;
        margin: 0 0 10px 10px;

        .el-checkbox__label {
          margin: 0 5px;
        }
      }

      li {
        list-style: none;
        line-height: 36px;
        padding: 0 20px;
        margin: 0;
        font-size: 14px;
        color: #606266;
        cursor: pointer;
        outline: none;
        text-align: center;
      }
    }

    .audit-table-filter__bottom {
      border-top: 1px solid #EBEEF5;
      padding: 13px;

      button {
        background: transparent;
        border: none;
        color: #606266;
        cursor: pointer;
        font-size: 13px;
        padding: 0 3px;

        
      }

      button.is-disabled {
        color: #C0C4CC;
        cursor: not-allowed;
      }
    }    
  }
  /deep/.el-table__header-wrapper .cell {
    line-height: 34px;
  }

  .inv-form-label {
    margin-top: 5px;
  }

  .filer-form-label {
    margin-top: 5px;
  }

  /deep/ .el-date-editor .el-range-separator {
    width: 7%
  }
</style>